import { IChatConfig, IChatConfigResponseCode, ISaveChatConfig } from "@interfaces/chat/chatConfig"
import fcUserServiceApiInstance from "@services/clients/fc-user"
import axiosApiInstance from "@services/custom-axios-instance"
import { generateUrl } from "@services/generateUrl/generateUrl"

export async function getChatSettings(usernameOrEmail: string, roleCode?:string): Promise<IChatConfig> 
{
    const endpoint = `/settings/user/chat/${usernameOrEmail}`;
    const resp = await fcUserServiceApiInstance.get<IChatConfig>(endpoint)
    return resp.data;
}

export async function saveChatSettings(usernameOrEmail: string, data: ISaveChatConfig): Promise<IChatConfigResponseCode> 
{
    const endpoint = "/settings/user/chat";
    const resp = await fcUserServiceApiInstance.post<IChatConfigResponseCode>(endpoint, data)
    return resp.data;
}

/**
 * @deprecated This endpoint was not migrated. Will be removed in future updates
 */
export const deleteChatConfig = async (profileChatSettingsId: number) => {
    try {
      return await axiosApiInstance
      .delete(
        `${generateUrl()}/drprox/chat/settings/${profileChatSettingsId}`
      )
    } catch (e) {
      throw new Error('something was wrong');
    }
  };
